const Sticky = require('sticky-js');
import VanillaScrollspy from 'vanillajs-scrollspy'
import _throttle from 'lodash.throttle'
import Gumshoe from 'gumshoejs'
import SmoothScroll from 'smooth-scroll'

const stickyEl = document.querySelector('.c-sticky-section');

if (stickyEl) {

  const storeStickySectionHeight = (height) => {
    const box = stickyEl.getBoundingClientRect()
    document.documentElement.style.setProperty('--sticky-section-height', `${box.height}px`)
    return box.height;
  }

  const headerEl = document.querySelector('.c-header');

  const storeHeaderHeight = (height) => {
    const box = headerEl.getBoundingClientRect()
    return box.height;
  }

  const anchorMenu = document.querySelector('.c-anchor-menu');

  const storeAnchorMenuHeight = (height) => {
    const mq = window.matchMedia('(min-width: 1024px)')
    if(anchorMenu && mq === true) {
      const box = anchorMenu.getBoundingClientRect()
      return box.height;
    }
    return 0;
  }

  window.addEventListener('resize', _throttle(() => storeStickySectionHeight(), 500))
  window.addEventListener('DOMContentLoaded', storeStickySectionHeight, { once: true })

  const scroll = () => {
    let elm = document.querySelector('.c-sticky-section');
    elm.dataset.stickyClass = 'is-sticky';
    elm.dataset.marginTop = storeHeaderHeight();
    elm.dataset.stickyWrap = 'true';
    elm.dataset.stickyFor = 1024;
    elm.closest('section:not(.c-sticky-section)').dataset.stickyContainer = 'true';
    let sticky = new Sticky('.c-sticky-section');

    const spy = new Gumshoe('.c-anchor-menu a',  {
      offset: function () {
        return storeHeaderHeight() + storeAnchorMenuHeight();
      },
      reflow: false,
    });

    document.addEventListener('gumshoeDeactivate', function (event) {
      setTimeout(() => {
        const ul = event.target.closest('ul');
        if(!ul.querySelector('li.active')) {
          ul.querySelector('li').classList.add('active');
        }
      }, 10)
    }, false);



    const scroll = new SmoothScroll('.c-anchor-menu a[href*="#"]', {
      offset: function (anchor, toggle) {
          return storeHeaderHeight() + storeAnchorMenuHeight() - 50;
      },
    });

    window.addEventListener('scroll', () => {
      let topValue = elm.style.top;

      if(parseFloat(topValue) <= 100) {
        elm.classList.add('was-sticky');
      }else {
        elm.classList.remove('was-sticky');
      }
    })
  };


  scroll();
}
